import React, { Component } from 'react';
import ArrowUpSVG from '../../svg/ArrowUpSVG';
import '../DatePicker.css'
import TodaySVG from '../../svg/TodaySVG';
import CloseUpSVG from '../../svg/CloseUpSVG';
import { Helper } from '../Helper';
import TimePicker from '../TimePicker';
import Popup from '../Popup';

class eventCalendar extends Component {

    constructor(props) {
        super(props);
        this.today = new Date();
        this.intervalVariable = 0;
        this.timeoutVariable = 0;
        this.dates = props.dates;

        this.state = {
            dates: props.dates ? props.dates : [],
            allowedDates: props.allowedDates ? props.allowedDates : [],
            useTime: props.useTime === undefined ? true : props.useTime,
            calendar: this.getCalendarArray(this.today.getFullYear(), this.today.getMonth()),
            currentYear: this.today.getFullYear(),
            currentMonth: this.today.getMonth(),
            currentDate: this.today.getDate(),
            regularCalendar: true,
            setFocusTo: -1,
            isOpen: false,
            incButtonDisabled: false,
            decButtonDisabled: false,
        };
    }

    updateStateDates = (date) => {
        let dates = [...this.state.dates];
        var foundDateIndex = dates.findIndex(dt => {
            return Helper.AreDatesEqual(dt.Date, date);
        });
        if (foundDateIndex >= 0) {
            dates.splice(foundDateIndex, 1);
        }
        else {
            let timeFrom = 0;
            let timeTo = 0;
            if (dates.length > 0) {
                timeFrom = dates[0].timeFrom;
                timeTo = dates[0].timeTo;
            }
            dates.push({
                date: date,
                timeFrom: timeFrom,
                timeTo: timeTo
            });
        }
        this.setState({
            dates: dates
        });
    }

    clearTimeoutAndInterval = () => {
        clearTimeout(this.timeoutVariable);
        clearInterval(this.intervalVariable);
        this.timeoutVariable = 0;
        this.intervalVariable = 0;
    }

    checkIfMonthIsWalkable = (currentYear, currentMonth, next) => {
        let month = currentMonth;
        let year = currentYear;
        if (next === true) {
            if (currentMonth < 11) { month = month + 1 }
            else { month = 0; year = year + 1 }
        }
        if (next === false) {
            if (currentMonth > 0) { month = month - 1 }
            else { month = 11; year = year - 1 }
        }
        let monthLastDay = new Date(year, month, 0).getDate();
        if (
            (this.props.minDate === undefined && new Date(year, month, 1) > this.props.maxDate) ||
            (this.props.maxDate === undefined && new Date(year, month, monthLastDay) < this.props.minDate)
        ) { return false }
        else return true;
    }

    checkIfYearIsWalkable = (currentYear, next) => {
        let year = currentYear;
        if (next === true) { year = year + 1 }
        if (next === false) { year = year - 1 }
        if (
            (this.props.minDate === undefined && new Date(year, 0, 1) > this.props.maxDate) ||
            (this.props.maxDate === undefined && new Date(year, 11, 31) < this.props.minDate)
        ) { return false }
        else return true;
    }

    checkIfActToday = (index) => {
        let date = this.state.calendar[index].date;
        return Helper.AreDatesEqual(date, this.today);
    }

    checkIfDisabled = (index) => {
        var curDate = this.state.calendar[index].date;
        if (this.props.allowedDates && this.props.allowedDates.length > 1) {
            //Allowed dates were set
            var foundDate = this.props.allowedDates.find(date => Helper.AreDatesEqual(date.date, curDate));
            if (foundDate) {
                return false;
            } else return true;
        }
        else if (this.props.minDate !== null && this.props.minDate !== undefined) {
            // the MIN date was set
            if (curDate < this.props.minDate) {
                return true;
            } else return false;
        }
        else {
            if (this.props.maxDate !== null && this.props.maxDate !== undefined) {
                // the MAX date was set
                if (curDate > this.props.maxDate) {
                    return true;
                }
                else return false;
            } else return false;
        }
    }


    getCalendarArray = (year, month) => {
        let actToday = new Date();
        let todayYear = actToday.getFullYear();
        let todayMonth = actToday.getMonth();
        let todayDate = actToday.getDate();
        //let setFocusTo = 0;
        let firstDayOfMonth = (new Date(year, month, 1)).getDay();
        let calendar = [];
        let prevMonth, prevYear, nextMonth, nextYear;
        let thisMonthNumberOfDays = new Date(year, month + 1, 0).getDate();
        let prevMonthNumberOfDays = new Date(year, month, 0).getDate();
        if (month > 0) {
            prevMonth = month - 1;
            prevYear = year;
        }
        else {
            prevMonth = 11;
            prevYear = year - 1;
        }
        if (month < 11) {
            nextMonth = month + 1;
            nextYear = year;
        }
        else {
            nextMonth = 0;
            nextYear = year + 1;
        }
        //PREVIOUS MONTH
        for (let i = prevMonthNumberOfDays - firstDayOfMonth + 1; i < prevMonthNumberOfDays + 1; i++) {
            calendar.push({ label: i, className: 'last-month', date: new Date(prevYear, prevMonth, i) });
        }
        //CURRENT MONTH
        for (let i = 0; i < thisMonthNumberOfDays; i++) {
            if ((year === todayYear) && (month === todayMonth) && (i + 1 === todayDate)) {
                calendar.push({ label: i + 1, className: 'actToday current-month', date: new Date(year, month, i + 1) })
                //setFocusTo = i + firstDayOfMonth;
            } else calendar.push({ label: i + 1, className: 'current-month', date: new Date(year, month, i + 1) })
        }
        //NEXT MONTH
        for (let i = 0; i < 42 - thisMonthNumberOfDays - firstDayOfMonth; i++) {
            calendar.push({ label: i + 1, className: 'next-month', date: new Date(nextYear, nextMonth, i + 1) });
        }

        return calendar;
    }

    incrementMonth = () => {
        if (this.state.currentMonth < 11) {
            this.createCalendar(this.state.currentYear, this.state.currentMonth + 1);
        } else {
            this.createCalendar(this.state.currentYear + 1, 0);
        };
    }

    decrementMonth = () => {
        if (this.state.currentMonth > 0) {
            this.createCalendar(this.state.currentYear, this.state.currentMonth - 1);
        } else this.createCalendar(this.state.currentYear - 1, 11);
    }

    incrementYear = () => {
        let currentYear = this.state.currentYear;
        let incButtonDisabled = !this.checkIfYearIsWalkable(currentYear + 1, true);
        let decButtonDisabled = !this.checkIfYearIsWalkable(currentYear + 1, false);
        if (currentYear < new Date().getFullYear() + 100) {
            this.setState(() => ({
                currentYear: currentYear + 1,
                incButtonDisabled: incButtonDisabled,
                decButtonDisabled: decButtonDisabled,
            }));
        }
    }

    decrementYear = () => {
        let currentYear = this.state.currentYear;
        let incButtonDisabled = !this.checkIfYearIsWalkable(currentYear - 1, true);
        let decButtonDisabled = !this.checkIfYearIsWalkable(currentYear - 1, false);
        if (currentYear > new Date().getFullYear() - 100) {
            this.setState(() => ({
                currentYear: currentYear - 1,
                incButtonDisabled: incButtonDisabled,
                decButtonDisabled: decButtonDisabled,
            }));
        }
    }

    onArrowClick = (increment) => {
        switch (increment) {
            case true:
                if (this.state.regularCalendar)
                {
                    if (this.checkIfMonthIsWalkable(this.state.currentYear, this.state.currentMonth, true)) {
                        this.incrementMonth()
                    }
                }
                else if (this.checkIfYearIsWalkable(this.state.currentYear, true)) {
                    this.incrementYear()
                }
                break;
            case false:
                if (this.state.regularCalendar) {
                    if (this.checkIfMonthIsWalkable(this.state.currentYear, this.state.currentMonth, false)) {
                        this.decrementMonth();
                        this.setState({ setFocusTo: -1 });
                    }
                }
                else if (this.checkIfYearIsWalkable(this.state.currentYear, false)) {
                    this.decrementYear();
                    this.setState({ setFocusTo: -1 });
                };
                break;
        }
    }

    createCalendar = (year, month, callback) => {
        let calendar = this.getCalendarArray(year, month)

        let incButtonDisabled = !this.checkIfMonthIsWalkable(year, month, true);
        let decButtonDisabled = !this.checkIfMonthIsWalkable(year, month, false);
        //check if to toggle the calendar
        if (this.state.regularCalendar) {
            this.setState({
                calendar: calendar,
                currentYear: year,
                currentMonth: month,
                setFocusTo: -1,
                incButtonDisabled: incButtonDisabled,
                decButtonDisabled: decButtonDisabled,
            }, () => { if (typeof callback === 'function') { callback() } });
        }
        else {
            this.setState({
                calendar: calendar,
                currentYear: year,
                currentMonth: month,
                regularCalendar: true,
                setFocusTo: -1,
                incButtonDisabled: incButtonDisabled,
                decButtonDisabled: decButtonDisabled,
            }, () => { if (typeof callback === 'function') { callback() } });
        }
    }


    performMultipleTimes = (callback) => {
        if (this.intervalVariable > 0) { return; }
        callback();
        this.timeoutVariable = setTimeout(() => {
            this.intervalVariable = setInterval(() => {
                callback();
            }, 100);
        }, 300);
    }

    updateFocus = () => {
        let setFocusTo = this.state.setFocusTo;
        if (this.state.regularCalendar) {
            if (this.setFocusTo < 0) {
                let value = this.props.value;
                let selectedDateIndex = -1;
                if (value !== undefined && value !== null && value !== '') {
                    selectedDateIndex = this.state.calendar.findIndex(day => {
                        return (day.date.getDate() === value.getDate() && day.date.getMonth() === value.getMonth() && day.date.getFullYear() === value.getFullYear())
                    });
                }
                let todayIndex = this.state.calendar.findIndex(day => { return day.className.includes("actToday") });
                let firstDayIndex = this.state.calendar.findIndex(day => { return day.className.includes("current-month") });
                if (selectedDateIndex > -1 /*&& !this.props.checkIfDisabled(selectedDateIndex)*/) { setFocusTo = selectedDateIndex; this.setProp("setFocusTo", selectedDateIndex) }
                else {
                    if (todayIndex > -1 && !this.checkIfDisabled(todayIndex)) { setFocusTo = todayIndex; this.setProp("setFocusTo", todayIndex) }
                    else {
                        if (!this.checkIfDisabled(firstDayIndex)) { setFocusTo = firstDayIndex; this.setProp("setFocusTo", firstDayIndex) }
                        else {
                            if (!this.checkIfDisabled(0)) { setFocusTo = 0; this.setProp("setFocusTo", 0) }
                        }
                    }
                }
            }
        } else {
            if (this.setFocusTo < 0) {
                let today = new Date();
                if (this.props.currentYear === today.getFullYear()) { setFocusTo = today.getMonth(); this.setProp("setFocusTo", today.getMonth()) }
                else { setFocusTo = 0; this.setProp("setFocusTo", 0) }
            }
        }
        return setFocusTo;
    }

    setProp = (propName, propValue, callback) => {
        let newState = { ...this.state };
        newState[propName] = propValue;
        if (callback && typeof callback == 'function') { this.setState({ newState }, callback) }
        else this.setState({ newState })
    }

    calendarKeyDownHandler(e) {
        let index = this.state.setFocusTo;
        if (index > -1) {
            let fullDate = this.state.calendar[index].date;
            switch (e.keyCode) {
                case 39: // Right Arrow
                    if (!(this.props.maxDate !== null &&
                        this.props.maxDate !== undefined &&
                        fullDate.getFullYear() === this.props.maxDate.getFullYear() &&
                        fullDate.getMonth() === this.props.maxDate.getMonth() &&
                        fullDate.getDate() === this.props.maxDate.getDate()
                    )) {
                        // if next date is not max date
                        if (index < 41) {
                            this.setState(() => ({ setFocusTo: index + 1 }));
                        }
                        else {
                            let date = fullDate.getDate();
                            let year = fullDate.getFullYear();
                            let month = fullDate.getMonth();
                            let firstDayOfMonth = (new Date(year, month, 1)).getDay();
                            //let lastDayOfMonth = this.amountOfDays(month, year);
                            // NOTE !!! There is no option the last day is the last day of the month
                            this.createCalendar(year, month);
                            this.setState({ setFocusTo: date + firstDayOfMonth });
                        }
                    }
                    break;
                case 37: //Left arrow
                    if (!(this.props.minDate !== null && this.props.minDate !== undefined &&
                        fullDate.getFullYear() === this.props.minDate.getFullYear() &&
                        fullDate.getMonth() === this.props.minDate.getMonth() &&
                        fullDate.getDate() === this.props.minDate.getDate()
                    )) {
                        // if previous date is not min date
                        if (index > 0) {
                            this.setState(() => ({ setFocusTo: index - 1 }));
                        }
                        else {
                            let date = fullDate.getDate();
                            let year = fullDate.getFullYear();
                            let month = fullDate.getMonth();
                            let firstDayOfMonth = (new Date(year, month, 1)).getDay();
                            if (date === 1) {
                                if (month > 0) {
                                    this.createCalendar(year, month - 1);
                                    this.setState({ setFocusTo: new Date(year, month-1, 0).getDate() + (new Date(year, month - 1, 1)).getDay() - 1 });
                                }
                                else {
                                    this.createCalendar(year - 1, 11);
                                    this.setState({ setFocusTo: new Date(year-1, 11, 0).getDate() + (new Date(year - 1, 11, 1)).getDay() - 1 });
                                }
                            }
                            else {
                                this.createCalendar(year, month);
                                this.setState({ setFocusTo: date - 1 + firstDayOfMonth - 1 });
                            }
                        }
                    }
                    break;

                case 38: /* Up Arrow */
                    {
                        let year = fullDate.getFullYear();
                        let month = fullDate.getMonth();
                        let date = fullDate.getDate();
                        let newDateYear = year;
                        let newDateMonth = month;
                        let newDateDate = date - 7;
                        if (newDateDate < 1) {
                            if (newDateMonth > 0) { newDateMonth = newDateMonth - 1; }
                            else {
                                newDateMonth = 11;
                                newDateYear = year - 1;
                            }
                            let newDateLastDayOfMonth = new Date(newDateYear, newDateMonth, 0).getDate();
                            newDateDate = date + newDateLastDayOfMonth - 7;
                        }
                        if (this.props.minDate === null || this.props.minDate === undefined || new Date(newDateYear, newDateMonth, newDateDate) >= this.props.minDate) {
                            this.createCalendar(newDateYear, newDateMonth);
                            let firstDayOfNewMonth = (new Date(newDateYear, newDateMonth, 1)).getDay();
                            this.setState({ setFocusTo: newDateDate + firstDayOfNewMonth - 1 });
                        }
                    }
                    e.preventDefault();
                    break;

                case 40: /* Down Arrow */
                    {
                        let year = fullDate.getFullYear();
                        let month = fullDate.getMonth();
                        let date = fullDate.getDate();
                        let lastDayOfMonth = new Date(year, month, 0).getDate();
                        let newDateYear = year;
                        let newDateMonth = month;
                        let newDateDate = date + 7;
                        if (newDateDate > lastDayOfMonth) {
                            if (month > 10) { newDateMonth = 0; newDateYear = year + 1 }
                            else { newDateMonth = month + 1; newDateYear = year; }
                            newDateDate = newDateDate - lastDayOfMonth;
                        }
                        if (this.props.maxDate === null || this.props.maxDate === undefined || new Date(newDateYear, newDateMonth, newDateDate) <= this.props.maxDate) {
                            this.createCalendar(newDateYear, newDateMonth);
                            let firstDayOfNewMonth = (new Date(newDateYear, newDateMonth, 1)).getDay();
                            if (newDateMonth === month) { this.setState({ setFocusTo: date + firstDayOfNewMonth + 6 }) }
                            else { this.setState({ setFocusTo: newDateDate + firstDayOfNewMonth - 1 }); }
                        }
                    }
                    e.preventDefault();
                    break;
                default: break;
            }
        } else { e.preventDefault() }
    }

    onSelect = (val) => {
        if (!this.props.onSelect) {
            this.updateStateDates(val);
        } else {
            this.props.onSelect(val);
        }
    }

    onTodayButtonClick = () => {
        this.createCalendar(this.today.getFullYear(), this.today.getMonth(), () => { this.calendarUlRef.focus() })
    }

    render() {

        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        var calendarContent = null;
        var dateArray = this.props.dates ? this.props.dates : this.state.dates;
        if (this.state.regularCalendar) {
            calendarContent =
                <div>
                <ul className='calendar-grid calendar-header light-grey-text uppercase-text nonselect'>
                    <li>Su</li>
                    <li>Mo</li>
                    <li>Tu</li>
                    <li>We</li>
                    <li>Th</li>
                    <li>Fr</li>
                    <li>Sa</li>
                </ul>
                <ul
                    ref={el => this.calendarUlRef = el}
                    className='calendar-grid calendar-content dark-grey-text'
                    tabIndex={0}
                    onKeyDown={e => {
                        if (e.keyCode === 13) { /* ENTER */
                            if (this.state.setFocusTo > -1) {
                                let fullDate = this.state.calendar[this.state.setFocusTo].date;
                                this.setProp('currentDate', fullDate);
                                this.onSelect(fullDate);
                                this.dropDownHeaderRef.focus();
                            }
                        } else this.calendarKeyDownHandler(e);
                    }}
                    onFocus={() => this.updateFocus() /*{if(this.updateFocus() < 0){this.monthButtonRef.focus(); }}*/}
                    onBlur={() => this.setState({ setFocusTo: -1 })}
                >
                    {this.state.calendar.map((element, index) => {
                        let disabled = this.checkIfDisabled(index);
                        let actToday = this.checkIfActToday(index);
                        let innerDivClassName = element.className;
                        let className = element.className +
                            (disabled ? " disabled" : "") +
                            (actToday ? " act-today" : "") +
                            (this.state.setFocusTo === index ? " onFocus" : "");
                        let elementContent = <strong>{element.label}</strong>;

                        let foundDateIndex = dateArray.findIndex(day => Helper.AreDatesEqual(day.date, element.date))
                        if (foundDateIndex > -1) {
                            let foundDate = dateArray[foundDateIndex];
                            let timeFrom = '';
                            let timeTo = '';

                            if (this.state.useTime) {
                                timeFrom = foundDate.timeFrom.hours.toString() + ':' + ('0' + foundDate.timeFrom.minutes.toString()).slice(-2) + ' ' + (foundDate.timeFrom.am ? "AM" : "PM");
                                timeTo = foundDate.timeTo.hours.toString() + ':' + ('0' + foundDate.timeTo.minutes.toString()).slice(-2) + ' ' + (foundDate.timeTo.am ? "AM" : "PM");
                            }
                            className = 'selected-date';
                            innerDivClassName = 'selected-date';
                            elementContent = <div>
                                <strong>{element.label}</strong>
                                {this.state.useTime &&
                                    <div>
                                        <a style={{ marginTop: "8px", fontSize: "0.7rem", fontWeight: "normal" }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.props.onSetDayTimesClick(foundDateIndex);
                                            }}>{timeFrom} - {timeTo}</a>
                                    </div>
                                }
                                </div>
                                //<TimePicker
                                //    onClick={(ctrl, e) => e.stopPropagation()}
                                //    timePickerMode={true}
                                //    value={800}
                                //    style={{ fontSize:"0.8rem" }}
                                //    onChange={value => {
                                //        //e.stopPropagation();

                                        //if (value.activated) { this.emptyTimeFrom = false; }
                                        //this.props.store.updateValidators("timeFrom", value, this.validators);
                                        //this.updateEventProperty("timeFrom", value);
                            //        }}
                            //    />
                            //</div>
                        }

                        return <li key={index}
                            className={className}
                            onClick={() => { if (!disabled) { this.onSelect(element.date) } }}
                        >
                        <div className={innerDivClassName}><strong>{elementContent}</strong></div>
                        </li>
                    })}
                </ul>
                </div>
        }
        else {
            calendarContent = <div className='flex-nowrap justify-center'>
                <ul
                    ref={el => this.calendarUlRef = el}
                    className='calendar-grid month-calendar-grid calendar-content dark-grey-text'
                    tabIndex={0}
                    onKeyDown={e => {
                        if (e.keyCode === 13) { /* ENTER */
                            if (this.state.setFocusTo > -1) {
                                this.createCalendar(this.state.currentYear, this.state.setFocusTo, () => { this.calendarUlRef.focus() })
                            }
                        } else this.props.monthPickerKeyDownHandler(e);
                    }}
                    onFocus={() => this.updateFocus()}
                    onBlur={() => { this.setState({ setFocusTo: -1 }) }}
                >
                    {monthNames.map((element, index) =>
                        <li
                            key={index}
                            onClick={() => this.createCalendar(this.state.currentYear, index)}
                            className={
                                element.className +
                                (this.checkIfMonthIsWalkable(this.state.currentYear, index, 5) ? "" : " disabled") +
                                /*(actToday ? " act-today" : "") + */
                                (this.state.setFocusTo === index ? " onFocus" : "")
                            }
                        >
                            <div>
                                <span><strong className='uppercase-text'>{element.slice(0, 3)}</strong></span>
                            </div>
                        </li>
                    )}
                </ul>
            </div>;
        }

        const getMonthNavButton = (toNextMonth, buttonRef, disabled) => {
            return <button
                ref={el => buttonRef = el}
                className={disabled ? 'arrow-button disabledButton' : 'arrow-button'}
                disabled={disabled}
                onMouseDown={() => this.performMultipleTimes(() => this.onArrowClick(toNextMonth))}
                onMouseUp={this.clearTimeoutAndInterval}
                onMouseOut={this.clearTimeoutAndInterval}
                onKeyDown={(e) => {
                    switch (e.keyCode) {
                        case 13:
                            this.performMultipleTimes(() => this.onArrowClick(toNextMonth));
                            e.preventDefault();
                            buttonRef.focus();
                            break;
                        case 9:
                            if (e.shiftKey) { this.returnToHeader(e) }
                            break;
                        case 27: break;
                        default:
                            e.preventDefault();
                            break;
                    }
                }}
                onKeyUp={this.clearTimeoutAndInterval}
            >
                <ArrowUpSVG svgClassName={toNextMonth ? 'flip180' : ''}/>
            </button>
        }

        const onMonthButtonClick = () => {
            let currentYear = this.state.currentYear;
            let currentMonth = this.state.currentMonth;
            let incButtonDisabled = false;
            let decButtonDisabled = false;
            if (this.state.regularCalendar) {
                incButtonDisabled = !this.checkIfYearIsWalkable(currentYear, true);
                decButtonDisabled = !this.checkIfYearIsWalkable(currentYear, false);
            }
            else {
                incButtonDisabled = !this.checkIfMonthIsWalkable(currentYear, currentMonth, true);
                decButtonDisabled = !this.checkIfMonthIsWalkable(currentYear, currentMonth, false);
            }
            this.setState(
                {
                    regularCalendar: !this.state.regularCalendar,
                    setFocusTo: -1,
                    incButtonDisabled: incButtonDisabled,
                    decButtonDisabled: decButtonDisabled,
                },
                () => {
                    this.updateFocus();
                    if (this.calendarUlRef !== null) { this.calendarUlRef.focus() }
                }
            );
        }

        return (
            <div
                ref={el => this.calendarBodyRef = el}
                className='flex-nowrap flex-flow-column align-center cw-100 date-picker-drop-down' /*absolute-drop-down*/
                style={this.opensBottom ? this.styleBottom : this.styleTop}
                onKeyDown={(e) => {
                    if (e.keyCode === 27) { this.props.toggle() }
                }}
            >
                <div className='flex-nowrap justify-stretch mb-05 mt-05 align-center'>
                    {getMonthNavButton(false, this.leftButtonRef, this.state.decButtonDisabled)}
                    <button
                        ref={el => this.monthButtonRef = el}
                        className="h2 uppercase-text flex11auto align-self-stretch no-outline-button"
                        style={{ "fontSize": "25px", "paddingBottom": "2px" }}
                        onClick={() => onMonthButtonClick()}
                        disabled={this.state.regularCalendar ? false : true}
                        onKeyDown={(e) => { if (e.keyCode === 13 /* ENTER */) { onMonthButtonClick() } }}
                    >
                        {this.state.regularCalendar && monthNames[this.state.currentMonth] + ' '}<strong><b>{this.state.currentYear}</b></strong>
                    </button>
                    {getMonthNavButton(true, this.rightButtonRef, this.state.incButtonDisabled)}
                </div>

                {calendarContent}
                {/*{this.state.regularCalendar &&
                    <ul className='calendar-grid calendar-header light-grey-text uppercase-text nonselect'>
                        <li>Su</li>
                        <li>Mo</li>
                        <li>Tu</li>
                        <li>We</li>
                        <li>Th</li>
                        <li>Fr</li>
                        <li>Sa</li>
                    </ul>
                }
                {this.state.regularCalendar &&
                    <ul
                        ref={el => this.calendarUlRef = el}
                        className='calendar-grid calendar-content dark-grey-text'
                        tabIndex={0}
                        onKeyDown={e => {
                            if (e.keyCode === 13) { // ENTER
                                if (this.props.setFocusTo > -1) {
                                    let fullDate = this.state.calendar[this.props.setFocusTo].date;
                                    this.props.setProp('currentDate', fullDate);
                                    this.props.onSelect(fullDate);
                                    this.props.toggle();
                                    this.props.dropDownHeaderRef.focus();
                                }
                            } else this.props.calendarKeyDownHandler(e);
                        }}
                        onFocus={() => this.updateFocus() //{if(this.updateFocus() < 0){this.monthButtonRef.focus(); }}}
                        onBlur={() => this.props.setProp('setFocusTo', -1)}
                    >
                        {this.state.calendar.map((element, index) => {
                            let disabled = this.checkIfDisabled(index);
                            let actToday = this.checkIfActToday(index);
                            return <li key={index}
                                className={
                                    element.className +
                                    (disabled ? " disabled" : "") +
                                    (actToday ? " act-today" : "") +
                                    (this.props.setFocusTo === index ? " onFocus" : "")
                                }
                                onClick={() => { if (!disabled) { this.props.onSelect(element.date) } }}
                            >
                                <div className={element.className}><strong>{element.label}</strong></div>
                            </li>
                        })}
                    </ul>
                }
                {!this.state.regularCalendar &&
                    <div className='flex-nowrap justify-center'>
                        <ul
                            ref={el => this.calendarUlRef = el}
                            className='calendar-grid month-calendar-grid calendar-content dark-grey-text'
                            tabIndex={0}
                            onKeyDown={e => {
                                if (e.keyCode === 13) { // ENTER 
                                    if (this.props.setFocusTo > -1) {
                                        this.props.createCalendar(this.state.currentYear, this.props.setFocusTo, () => { this.calendarUlRef.focus() })
                                    }
                                } else this.props.monthPickerKeyDownHandler(e);
                            }}
                            onFocus={() => this.updateFocus()}
                            onBlur={() => { this.props.setProp('setFocusTo', -1) }}
                        >
                            {monthNames.map((element, index) =>
                                <li
                                    key={index}
                                    onClick={() => this.props.createCalendar(this.state.currentYear, index)}
                                    className={
                                        element.className +
                                        (this.checkIfMonthIsWalkable(this.state.currentYear, index, 5) ? "" : " disabled") +
                                        //(actToday ? " act-today" : "") + 
                                        (this.props.setFocusTo === index ? " onFocus" : "")
                                    }
                                >
                                    <div>
                                        <span><strong className='uppercase-text'>{element.slice(0, 3)}</strong></span>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>
                }*/}

                {this.checkIfMonthIsWalkable((new Date).getFullYear(), (new Date).getMonth(), 5) &&
                    <button
                        style={{ 'flexShrink': '0' }}
                        className='round-button medium-round-button no-outline-button'
                        onClick={() => this.onTodayButtonClick()}
                        onKeyDown={e => {
                            switch (e.keyCode) {
                                case 9: /* TAB */
                                    if (!e.shiftKey) { this.returnToHeader(e) }
                                    break;
                                case 13: /* ENTER */
                                    this.onTodayButtonClick();
                                    break;
                                default: break;
                            }
                        }}
                    >
                        <span>current month</span>
                    </button>
                }
            </div>
        );
    }
}

export default eventCalendar;


// WEBPACK FOOTER //
// ./src/components/event/EventCalendar.jsx